import { authLoader } from '../../auth/guards';
import LoginForm from './components/LoginForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import AuthLayout from './components/AuthLayout';

/**
 * `authLoader` sits on `/login` rather than on the group: it bounces anyone with a valid
 * session back to `/`, which is right for the login screen but would make the sidebar's
 * Change Password link a no-op. `/reset-password` is deliberately reachable both signed
 * out (via the login page) and signed in (via the sidebar).
 */
export const authRoutes = {
  element: <AuthLayout />,
  children: [
    { path: '/login', element: <LoginForm />, loader: authLoader },
    { path: '/reset-password', element: <ResetPasswordForm /> },
  ],
};
